import type { MapAspect, MapProps, MapProvider } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { NumberField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const PROVIDER = ["openstreetmap", "google"] as const;
const ASPECT = ["16/9", "4/3", "1/1", "21/9"] as const;

export function MapInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as MapProps;

  return (
    <>
      <SelectField
        label="Provider"
        value={p.provider}
        options={PROVIDER}
        onChange={(v) => update(widget.id, { provider: v as MapProvider })}
      />
      <TextField
        label={p.provider === "google" ? "Place query" : "Lat,Lng (e.g. 18.48,-69.93)"}
        value={p.query}
        onChange={(v) => update(widget.id, { query: v })}
      />
      <NumberField
        label="Zoom"
        value={p.zoom ?? 12}
        min={1}
        max={20}
        onChange={(v) => update(widget.id, { zoom: v })}
      />
      <SelectField
        label="Aspect ratio"
        value={p.aspectRatio ?? "16/9"}
        options={ASPECT}
        onChange={(v) => update(widget.id, { aspectRatio: v as MapAspect })}
      />
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 12}
        min={0}
        max={32}
        onChange={(v) => update(widget.id, { radius: v })}
      />
      <TextField
        label="Title / link label"
        value={p.title ?? ""}
        onChange={(v) => update(widget.id, { title: v || undefined })}
      />
    </>
  );
}
